import React from "react"
import {
    FacebookShareButton,
    TwitterShareButton,
    LinkedinShareButton,
    PinterestShareButton,
    RedditShareButton,
} from "react-share"
import {
    HorizontalStack,
    HeadingLarge,
    Box,
} from "@mallardbay/lib-react-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFacebookF } from "@fortawesome/free-brands-svg-icons/faFacebookF"
import { faTwitter } from "@fortawesome/free-brands-svg-icons/faTwitter"
import { faLinkedin } from "@fortawesome/free-brands-svg-icons/faLinkedin"
import { faPinterest } from "@fortawesome/free-brands-svg-icons/faPinterest"
import { faReddit } from "@fortawesome/free-brands-svg-icons/faReddit"

import { TEST_IDS } from "~config/test-ids"

interface Props {
    readonly imageUrl?: string | null
}

export default function BlogEntrySocials({ imageUrl }: Props) {
    const url = process.env.GATSBY_WEB_HOST ?? ""

    const buttonProps = {
        url,
    }

    return (
        <Box data-testId={TEST_IDS.BLOG_ENTRY_SOCIALS}>
            <HorizontalStack>
                <FacebookShareButton {...buttonProps}>
                    <HeadingLarge>
                        <FontAwesomeIcon icon={faFacebookF} />
                    </HeadingLarge>
                </FacebookShareButton>
                <TwitterShareButton {...buttonProps}>
                    <HeadingLarge>
                        <FontAwesomeIcon icon={faTwitter} />
                    </HeadingLarge>
                </TwitterShareButton>
                <LinkedinShareButton {...buttonProps}>
                    <HeadingLarge>
                        <FontAwesomeIcon icon={faLinkedin} />
                    </HeadingLarge>
                </LinkedinShareButton>
                {imageUrl && (
                    <PinterestShareButton {...buttonProps} media={imageUrl}>
                        <HeadingLarge>
                            <FontAwesomeIcon icon={faPinterest} />
                        </HeadingLarge>
                    </PinterestShareButton>
                )}
                <RedditShareButton {...buttonProps}>
                    <HeadingLarge>
                        <FontAwesomeIcon icon={faReddit} />
                    </HeadingLarge>
                </RedditShareButton>
            </HorizontalStack>
        </Box>
    )
}
